import { tedMediaArray } from './tedMedia'
import { tedBio } from './tedBios'
import { stellaProfileReviewTinder, robinProfileReviewHinge, zoeyProfileReviewBumble } from './tedProfileReviews'

export const tedDatingProfileHinge = {
  _id: 'tedDatingProfileHingeId',
  userId: 'tedUserId',
  email: 'ted@email.com',
  type: 'hinge',
  // vibes: ['classy', 'fun', 'relaxed'],
  media: [
    {
      mediaItemId: tedMediaArray[12]._id,
      mediaItemURL: tedMediaArray[12].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: tedMediaArray[12].type,
      caption: tedMediaArray[12].captions[0],
      subcaption: tedMediaArray[12].subcaptions[2],
    },
    {
      mediaItemId: tedMediaArray[11]._id,
      mediaItemURL: tedMediaArray[11].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: tedMediaArray[11].type,
      caption: tedMediaArray[11].captions[1],
      subcaption: tedMediaArray[11].subcaptions[1],
    },
    {
      mediaItemId: tedMediaArray[10]._id,
      mediaItemURL: tedMediaArray[10].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: tedMediaArray[10].type,
      caption: tedMediaArray[10].captions[0],
      subcaption: tedMediaArray[10].subcaptions[2],
    },
    {
      mediaItemId: tedMediaArray[9]._id,
      mediaItemURL: tedMediaArray[9].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: tedMediaArray[9].type,
      caption: tedMediaArray[9].captions[2],
      subcaption: tedMediaArray[9].subcaptions[0],
    },
    {
      mediaItemId: tedMediaArray[7]._id,
      mediaItemURL: tedMediaArray[7].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: tedMediaArray[7].type,
      caption: tedMediaArray[7].captions[2],
      subcaption: tedMediaArray[7].subcaptions[0],
    },
    {
      mediaItemId: tedMediaArray[3]._id,
      mediaItemURL: tedMediaArray[3].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: tedMediaArray[3].type,
      caption: tedMediaArray[3].captions[0],
      subcaption: tedMediaArray[3].subcaptions[2],
    }
  ],
  bio: {
    bioItemsId: tedBio._id,
    vitalInfo: { ...tedBio.vitalInfo },
    prompts: [
      { ...tedBio.prompts[0] },
      { ...tedBio.prompts[1] },
      { ...tedBio.prompts[2] }
    ],
    aboutMe: '',
    hobbies: ['', '', '', '', ''],
  },
  profileReviews: [
    { ...robinProfileReviewHinge }
  ],
  mediaItems: [ ...tedMediaArray ],
  bioItems: { ...tedBio },
}

export const tedDatingProfileBumble = {
  _id: 'tedDatingProfileBumbleId',
  userId: 'tedUserId',
  email: 'ted@email.com',
  type: 'bumble',
  // vibes: ['classy', 'fun', 'relaxed'],
  media: [
    {
      mediaItemId: tedMediaArray[10]._id,
      mediaItemURL: tedMediaArray[10].portraitURL,
      mediaType: tedMediaArray[10].type,
      caption: tedMediaArray[10].captions[0],
      subcaption: tedMediaArray[10].subcaptions[2],
    },
    {
      mediaItemId: tedMediaArray[11]._id,
      mediaItemURL: tedMediaArray[11].portraitURL,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: tedMediaArray[11].type,
      caption: tedMediaArray[11].captions[1],
      subcaption: tedMediaArray[11].subcaptions[1],
    },
    {
      mediaItemId: tedMediaArray[3]._id,
      mediaItemURL: tedMediaArray[3].portraitURL,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: tedMediaArray[3].type,
      caption: tedMediaArray[3].captions[0],
      subcaption: tedMediaArray[3].subcaptions[2],
    },
    {
      mediaItemId: tedMediaArray[9]._id,
      mediaItemURL: tedMediaArray[9].portraitURL,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: tedMediaArray[9].type,
      caption: tedMediaArray[9].captions[2],
      subcaption: tedMediaArray[9].subcaptions[0],
    },
    {
      mediaItemId: tedMediaArray[12]._id,
      mediaItemURL: tedMediaArray[12].portraitURL,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: tedMediaArray[12].type,
      caption: tedMediaArray[12].captions[0],
      subcaption: tedMediaArray[12].subcaptions[2],
    },
    {
      mediaItemId: tedMediaArray[7]._id,
      mediaItemURL: tedMediaArray[7].portraitURL,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: tedMediaArray[7].type,
      caption: tedMediaArray[7].captions[2],
      subcaption: tedMediaArray[7].subcaptions[0],
    }
  ],
  bio: {
    bioItemsId: tedBio._id,
    vitalInfo: { ...tedBio.vitalInfo },
    prompts: [
      { ...tedBio.prompts[0] },
      { ...tedBio.prompts[1] },
      { ...tedBio.prompts[2] }
    ],
    aboutMe: tedBio.aboutMe[0],
    hobbies: [tedBio.hobbies[0], tedBio.hobbies[1], tedBio.hobbies[2], tedBio.hobbies[3], tedBio.hobbies[4] ],
  },
  profileReviews: [
    { ...zoeyProfileReviewBumble }
  ],
  mediaItems: [ ...tedMediaArray ],
  bioItems: { ...tedBio },
}

export const tedDatingProfileTinder = {
  _id: 'tedDatingProfileTinderId',
  userId: 'tedUserId',
  email: 'ted@email.com',
  type: 'tinder',
  // vibes: ['classy', 'fun', 'relaxed'],
  media: [
    {
      mediaItemId: tedMediaArray[3]._id,
      mediaItemURL: tedMediaArray[3].portraitURL,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: tedMediaArray[3].type,
      caption: tedMediaArray[3].captions[0],
      subcaption: tedMediaArray[3].subcaptions[2],
    },
    {
      mediaItemId: tedMediaArray[11]._id,
      mediaItemURL: tedMediaArray[11].portraitURL,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: tedMediaArray[11].type,
      caption: tedMediaArray[11].captions[1],
      subcaption: tedMediaArray[11].subcaptions[1],
    },
    {
      mediaItemId: tedMediaArray[10]._id,
      mediaItemURL: tedMediaArray[10].portraitURL,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: tedMediaArray[10].type,
      caption: tedMediaArray[10].captions[0],
      subcaption: tedMediaArray[10].subcaptions[2],
    },
    {
      mediaItemId: tedMediaArray[7]._id,
      mediaItemURL: tedMediaArray[7].portraitURL,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: tedMediaArray[7].type,
      caption: tedMediaArray[7].captions[2],
      subcaption: tedMediaArray[7].subcaptions[0],
    },
    {
      mediaItemId: tedMediaArray[9]._id,
      mediaItemURL: tedMediaArray[9].portraitURL,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: tedMediaArray[9].type,
      caption: tedMediaArray[9].captions[2],
      subcaption: tedMediaArray[9].subcaptions[0],
    },
    {
      mediaItemId: tedMediaArray[12]._id,
      mediaItemURL: tedMediaArray[12].portraitURL,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: tedMediaArray[12].type,
      caption: tedMediaArray[12].captions[0],
      subcaption: tedMediaArray[12].subcaptions[2],
    }
  ],
  bio: {
    bioItemsId: tedBio._id,
    vitalInfo: { ...tedBio.vitalInfo },
    prompts: [
      { ...tedBio.prompts[0] },
      { ...tedBio.prompts[1] },
      { ...tedBio.prompts[2] }
    ],
    aboutMe: tedBio.aboutMe[0],
    hobbies: [tedBio.hobbies[0], tedBio.hobbies[1], tedBio.hobbies[2], tedBio.hobbies[3], tedBio.hobbies[4] ],
  },
  profileReviews: [
    { ...stellaProfileReviewTinder }
  ],
  mediaItems: [ ...tedMediaArray ],
  bioItems: { ...tedBio },
}